<dialog
  #dialog
  class="recording-consent-dialog"
  aria-labelledby="recording-consent-title"
  aria-describedby="recording-consent-text"
  (close)="onClose()"
  (click)="onDialogClick($event)">
  <div class="card">
    <div class="title">
      <fa-duotone-icon [icon]="faMicrochipAi"></fa-duotone-icon>
      <h2 id="recording-consent-title">
        {{ 'Session is being recorded and transcribed' | translate }}
      </h2>
    </div>

    <p id="recording-consent-text" class="message">
      {{ 'This conversation is now being recorded and transcribed.' | translate }}
      {{ 'Your microphone stays muted until you confirm.' | translate }}
    </p>

    @if (startedByName()) {
      <p class="owner">{{ 'Recording started by' | translate: { name: startedByName() } }}</p>
    }

    <div class="actions">
      <button type="button" class="cancel" (click)="dismiss()">
        {{ 'Stay muted' | translate }}
      </button>
      <button type="button" class="confirm" autofocus (click)="consent()">
        {{ 'I understand' | translate }}
      </button>
    </div>
  </div>
</dialog>
